module.exports = __webpack_public_path__ + "img/12_Mid-body.170fcd8e.png";